<table class="space">
  <th colspan="2">{{ cardDisclosures()?.title }}</th>
  @for (data of cardDisclosures()?.data; track data) {
    <tr>
      <td class="bewp-left-col" [innerHTML]="data.col1"></td>
      <td [innerHTML]="data.col2"></td>
    </tr>
  }
</table>
